import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: block;
`;

export {
  Wrapper
};
